<template>
<div class="content-body tenant-settings">
    <div class="">
        <el-form :inline="true" :model="dataForm" @keyup.enter.native="queryHandle()" size="small">
            <el-form-item label="子公司" prop="subcompanyId">
                <el-select
                    v-model="dataForm.subcompanyId"
                    class="input-width"
                    placeholder="请选择子公司"
                    clearable
                    filterable
                >
                    <el-option
                        v-for="item in supCompanyList"
                        :key="item.id"
                        :label="item.orgName"
                        :value="item.id"
                    >
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="采购员">
                <el-select
                    size="small"
                    v-model="dataForm.groupCode"
                    :disabled="ekgrpSelectDisabled"
                    placeholder="请选择采购员"
                    filterable
                    clearable
                >
                    <el-option
                        v-for="item in groupList"
                        :key="item?.value || ''"
                        :label="item?.label || ''"
                        :value="item?.value || ''"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="交货时间从:">
                <el-date-picker
                    v-model="dataForm.deliveryDateStart"
                    style="width:200px"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    type="date"
                    clearable
                    placeholder="选择开始日期"
                ></el-date-picker>
            </el-form-item>
            <el-form-item label="交货时间至:">
                <el-date-picker
                    v-model="dataForm.deliveryDateEnd"
                    style="width:200px"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    type="date"
                    clearable
                    placeholder="选择结束日期"
                ></el-date-picker>
            </el-form-item>
            <el-form-item label="ASN单号:">
                <el-input size="small" v-model="dataForm.asnCode" placeholder="ASN单号" clearable></el-input>
            </el-form-item>
            <el-form-item label="器具编码:">
                <el-input size="small" v-model="dataForm.containerCode" placeholder="器具编码" clearable></el-input>
            </el-form-item>
            <el-form-item label="器具名称:">
                <el-input size="small" v-model="dataForm.containerName" placeholder="器具名称" clearable></el-input>
            </el-form-item>
            <el-form-item label="物料号:">
                <el-input size="small" v-model="dataForm.partCode" placeholder="物料号" clearable style="width:180px">
                    <template slot="append">
                        <el-checkbox v-model="dataForm.partCodeFuzzy" style="margin-left:5px;">模糊</el-checkbox>
                    </template>
                </el-input>
            </el-form-item>
            <el-form-item class="fr">
                <el-button size="small" @click="queryHandle()" icon="el-icon-search">
                    查询
                </el-button>
            </el-form-item>
        </el-form>
        <div v-loading="dataListLoading">
            <el-table :data="dataList" row-key="id" size="mini" border style="width: 100%;"
                :header-cell-style="{background:'#f5f5f5'}" :height="tableHeight">
                <el-table-column type="index" width="50" label="序号" header-align="center" align="center">
                    <template slot-scope="scope">
                        {{ scope.$index + 1 + (pageIndex - 1) * pageSize }}
                    </template>
                </el-table-column>
                <el-table-column prop="factoryCode" header-align="center" align="center" label="工厂代码" width="100">
                </el-table-column>
                <el-table-column prop="companyName" header-align="center" align="left" label="公司名称" width="200">
                </el-table-column>
                <el-table-column prop="containerCode" header-align="center" align="left" label="器具编码" width="120">
                </el-table-column>
                <el-table-column prop="containerName" header-align="center" align="left" label="器具名称" width="150">
                </el-table-column>
                <el-table-column prop="asnCode" header-align="center" align="left" label="交货单号" width="150">
                </el-table-column>
                <el-table-column prop="partCode" header-align="center" align="left" label="物料号" width="120">
                </el-table-column>
                <el-table-column prop="partName" header-align="center" align="left" label="物料名称" width="150">
                </el-table-column>
                <el-table-column prop="containerQty" header-align="center" align="right" label="箱数/器具数" width="100">
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <el-pagination
                @size-change="sizeChangeHandle"
                @current-change="currentChangeHandle"
                :current-page="pageIndex"
                :page-sizes="[10, 20, 50]"
                :page-size="pageSize"
                :total="totalPage"
                layout="total, sizes, prev, pager, next, jumper"
            >
            </el-pagination>
        </div>
    </div>
</div>
</template>

<script>
import {
    getGroupList,
    getCurrentUserDataAuthority,
} from "@/controller/order"
import { getAsnContainerDetail } from '@/controller/delivery'
import { supCompanyList } from '@/controller/sys'

export default {
    data() {
        return {
            documentClientHeight: document.documentElement['clientHeight'] - 250,
            dataForm: {
                subcompanyId: '',
                groupCode: '',
                deliveryDateStart: '',
                deliveryDateEnd: '',
                asnCode: '',
                containerCode: '',
                containerName: '',
                partCode: '',
                partCodeFuzzy: false,
            },
            supCompanyList: [],
            groupList: [],
            ekgrpSelectDisabled: false,
            dataList: [],
            pageIndex: 1,
            pageSize: 10,
            totalPage: 0,
            dataListLoading: false,
        };
    },
    computed: {
        tableHeight() {
            return this.documentClientHeight;
        },
    },
    activated() {
        this.getSupCompanyList()
        this.getCurrentUserDataAuthority()
    },
    methods: {
        // 获取子公司列表
        getSupCompanyList() {
            supCompanyList().then((data) => {
                if (data && data.code === '00') {
                    this.supCompanyList = data.body;
                }
            });
        },
        // 获取当前用户数据权限
        getCurrentUserDataAuthority() {
            getCurrentUserDataAuthority({}).then((data) => {
                if (data.body == null || data.body.dataAuthority === '0' || data.body.dataAuthority == null) {
                    this.ekgrpSelectDisabled = true;
                }
                this.getGroupListNew();
            });
        },
        // 获取采购组列表（含权限过滤）
        getGroupListNew() {
            getGroupList({}).then((data) => {
                if (data && data.code === '00') {
                    this.groupList = data.body;
                }
            });
        },
        // 查询按钮
        queryHandle() {
            this.pageIndex = 1;
            this.getDataList();
        },
        // 获取数据列表
        getDataList() {
            this.dataListLoading = true;
            const params = {
                pageNo: this.pageIndex,
                pageSize: this.pageSize,
                subcompanyId: this.dataForm.subcompanyId || null,
                groupCode: this.dataForm.groupCode || null,
                deliveryDateStart: this.dataForm.deliveryDateStart || null,
                deliveryDateEnd: this.dataForm.deliveryDateEnd || null,
                asnCode: this.dataForm.asnCode || null,
                containerCode: this.dataForm.containerCode || null,
                containerName: this.dataForm.containerName || null,
                partCode: this.dataForm.partCode || null,
                partCodeFuzzy: this.dataForm.partCodeFuzzy || false,
            };
            getAsnContainerDetail(params).then((data) => {
                if (data && data.code === '00') {
                    const records = data.body.records;
                    this.dataList = records;
                    this.totalPage = data.body.total;
                } else {
                    this.dataList = [];
                    this.totalPage = 0;
                }
            }).catch(() => {
                this.dataList = [];
                this.totalPage = 0;
            }).finally(() => {
                this.dataListLoading = false;
            });
        },
        // 每页条数改变
        sizeChangeHandle(val) {
            this.pageSize = val;
            this.pageIndex = 1;
            this.getDataList();
        },
        // 当前页改变
        currentChangeHandle(val) {
            this.pageIndex = val;
            this.getDataList();
        },
    },
};
</script>

<style lang="scss" scoped>
.input-width {
    width: 200px;
}
</style>
